var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circular-menu"},[_c('div',{ref:"center",staticClass:"center"},[_vm._t("center")],2),_c('div',{ref:"satellites",staticClass:"satellites"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }